import { separateEntity } from 'config';

export const separateEntityNotificationMessage = (creditSummary) => {
  const { notifyInd, cardInactiveTs } = creditSummary;
  if (notifyInd === 'SE_MATCH') {
    return separateEntity[notifyInd]();
  }
  if (notifyInd === 'SE_MISMATCH') {
    if (new Date() <= new Date(cardInactiveTs)) {
      return separateEntity[notifyInd](true);
    }
    return separateEntity[notifyInd](false);
  }
  if (notifyInd === 'SE_MISMATCH_MPAY') {
    if (new Date() <= new Date(cardInactiveTs)) {
      return separateEntity[notifyInd](true);
    }
    return separateEntity[notifyInd](false);
  }
  return '';
};
